import React from "react";
import ActionModalWithModal from "../components/StaffCard/ActionModalWithModal";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const StaffActionDropdown = ({
  type,
  officeId,
  data,
  globalStaffPage,
  officeDetail,
  selectedId,
  staffActionsSubstitueActionSetter,
  t,
}) => {
  const history = useHistory();
  return (
    <div className="staff-dropdown">
      <ActionModalWithModal
        type={type}
        officeId={officeId}
        detail={data}
        t={t}
        resetApi={() => history.goBack()}
        globalStaffPage={globalStaffPage}
        officeData={officeDetail}
        selectedId={selectedId}
        detailPage={true}
        staffActionsSubstitueActionSetter={staffActionsSubstitueActionSetter}
      />
    </div>
  );
};

export default StaffActionDropdown;
